module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step2b_Image20.f0b95072.jpg";